import { RootState } from '@app/store';
import { useAppDispatch, useAppSelector } from '@app/store/hooks';

import { setIsOpenPanel, setIsOpenParkingPanel } from '../model/slice';

export const useSidePanel = () => {
	const dispatch = useAppDispatch();
	const { isOpenParkingPanel, isOpenPanel } = useAppSelector((state: RootState) => state.sidePanel);

	return {
		isOpenParkingPanel,
		isOpenPanel,
		setIsOpenPanel: (isOpen: boolean) => {
			dispatch(setIsOpenPanel(isOpen));
		},
		setIsOpenParkingPanel: (isOpen: boolean) => {
			dispatch(setIsOpenParkingPanel(isOpen));
		},
	};
};
